import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, Observable } from 'rxjs';
import { SnackbarComponent } from 'src/app/shared/components/snackbar/snackbar.component';

import { ErrorResponse } from '../interfaces/error-response.interface';
import { ErrorActions } from './error.slice';

@Injectable()
export class ErrorEffects {
  /* HANDLE ERROR */
  handleError$ = createEffect(
    (): Observable<void> =>
      this.actions$.pipe(
        ofType(ErrorActions.handleError),
        filter((action: ErrorResponse) => !!action.message),
        map((action: ErrorResponse): void => {
          this._snackBar.openFromComponent(SnackbarComponent, {
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            duration: 7000,
            data:
              action.message +
              (action?.fieldErrors && Object.keys(action?.fieldErrors).length
                ? '\n' + JSON.stringify(action.fieldErrors)
                : '') +
              (action?.globalErrors && Object.keys(action?.globalErrors).length
                ? '\n' + JSON.stringify(action.globalErrors)
                : ''),
          });
        })
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions, private _snackBar: MatSnackBar) {}
}
